exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.buttons___3d5V6 button {\n  margin-right: 12px;\n  margin-top: 12px;\n  min-width: 200px;\n}\n.buttons___3d5V6 a:hover {\n  text-decoration: none !important;\n}\n.box___2-g4b {\n  display: flex;\n  flex-direction: column;\n  padding: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"buttons": "buttons___3d5V6",
	"box": "box___2-g4b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/SingleSample/CartError/styles.module.less
// module id = 1615
// module chunks = 51